import * as React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { Divider } from '@mui/material';

const useStyles = makeStyles((theme: Theme) => ({
  separator: {
    width: '100%',
  },
}));

const Separator: React.FC = (): JSX.Element => {
  const classes = useStyles({});
  return <Divider variant='fullWidth' className={classes.separator} />;
};

export default Separator;
